import { GetAxiosInstance } from '../baseService';
import { ServiceLocation } from '../serviceLocationsAxios';
import {
  GetAttachmentQueryParams,
  AttachmentDto,
  PodDto,
  AttachmentTypeDto,
  GetTrackingStatusImageBysalesOrderIdQueryParams,
  TrackingAttachmentDto,
  GetAttachmentByidFileQueryParams,
  GetTrackingStatusImageByidFileQueryParams,
  GetTrackingPodQueryParams,
  GetAttachmentTypeQueryParams,
  GetDtoQueryParams,
  DtoDto,
  AttachmentModel,
  GetEntityTypeAllowedAttachmentTypeQueryParams,
  EntityTypeAllowedAttachmentTypeDto,
  BaseModel,
  GetServiceQueryParams,
  ServiceDto,
  GetDtoByidQueryParams,
  GetTrackingPoddetailsQueryParams,
  TrackingPodDto,
  BooleanApiResponse,
  AttachmentDtoApiResponse
} from 'src/models/attachment';
import { AxiosRequestConfig } from 'axios';

export const getDtoById = async (id: string, params?: GetDtoByidQueryParams) => {
  return GetAxiosInstance(undefined, undefined, undefined, undefined, undefined, undefined, true).get<DtoDto>(
    `${ServiceLocation.attachment}/Dto/${id}`,
    { params }
  );
};

/**
 * Get entity type allowed attachment types
 * @param params GetEntityTypeAllowedAttachmentTypeQueryParams
 * @returns EntityTypeAllowedAttachmentTypeDto[]
 */
export const getEntityTypeAllowedAttachmentTypes = async (params?: GetEntityTypeAllowedAttachmentTypeQueryParams) => {
  return GetAxiosInstance().get<EntityTypeAllowedAttachmentTypeDto[]>(
    ServiceLocation.attachment + '/EntityTypeAllowedAttachmentType',
    { params }
  );
};

//get attachment Types
export const getAttachmentTypes = async (params?: GetAttachmentTypeQueryParams) => {
  return GetAxiosInstance(undefined, undefined, undefined, undefined, undefined, undefined, true).get<
    AttachmentTypeDto[]
  >(ServiceLocation.attachment + '/AttachmentType', { params });
};

/**
 * Get Attachments
 *
 * @param params GetAttachmentQueryParams
 * @returns AttachmentDto[]
 */
export const getAttachments = (params?: GetAttachmentQueryParams) => {
  return GetAxiosInstance().get<AttachmentDto[]>(`${ServiceLocation.attachment}/Attachment`, { params });
};

/**
 * Get attachments for pod
 *
 * @param params
 * @returns
 */
export const getPod = (params?: GetTrackingPodQueryParams) => {
  return GetAxiosInstance().get<PodDto[]>(ServiceLocation.attachment + '/Tracking/pod', {
    params
  });
};

/**
 * Get Tracking Attachments by Sales Order Id
 * @param id Id of the Sales Order
 * @param params GetTrackingStatusImageBysalesOrderIdQueryParams
 * @returns TrackingAttachmentDto[]
 */
export const getTrackingAttachments = (id: string, params?: GetTrackingStatusImageBysalesOrderIdQueryParams) => {
  return GetAxiosInstance().get<TrackingAttachmentDto[]>(ServiceLocation.attachment + '/Tracking/statusImage/' + id, {
    params
  });
};

/**
 * Get Tracking Attachment File by Id
 * @param id Id of the attachment
 * @param params GetTrackingStatusImageByidFileQueryParams
 * @returns Blob
 */
export const getTrackingAttachmentFile = (id: string, params?: GetTrackingStatusImageByidFileQueryParams) => {
  return GetAxiosInstance(undefined, undefined, undefined, undefined, 'blob').get<any>(
    ServiceLocation.attachment + '/Tracking/statusImage/' + id + '/file',
    { params }
  );
};

/**
 * Get file as blob
 */
export const getFile = (id: string, params?: GetAttachmentByidFileQueryParams) => {
  return GetAxiosInstance(undefined, undefined, undefined, undefined, 'blob').get<any>(
    ServiceLocation.attachment + '/Attachment/' + id + '/file',
    { params }
  );
};

/**
 * Get attachment file
 */
export const getAttachmentFile = (id: string, params?: GetAttachmentByidFileQueryParams) => {
  return GetAxiosInstance().get<any>(`${ServiceLocation.attachment}/Attachment/${id}/file`, { params });
};

/**
 * Get attachment file base64 string
 */
export const getAttachmentBase64 = (id: string) => {
  return GetAxiosInstance().get<string>(`${ServiceLocation.attachment}/Attachment/${id}/file/base64`);
};

/**
 * Delete attachment by id
 *
 * @param params
 * @returns
 */
export const deleteAttachmentById = (id: string, config: AxiosRequestConfig<BaseModel>) => {
  return GetAxiosInstance().delete<BooleanApiResponse>(`${ServiceLocation.attachment}/Attachment/${id}`, config);
};

/**
 * Get Dtos (Attachment Service)
 * @param params GetDtoQueryParams
 * @returns DtoDto[]
 */
export const getAttachmentDtos = (params?: GetDtoQueryParams) => {
  return GetAxiosInstance().get<DtoDto[]>(ServiceLocation.attachment + '/dto', { params });
};

/**
 * Update attachment
 *
 * @param id
 * @param model
 * @returns
 */
export const toggleAttachmentIsHidden = (id: string, model: AttachmentModel) => {
  return GetAxiosInstance().put<AttachmentDtoApiResponse>(
    `${ServiceLocation.attachment}/Attachment/${id}/toggleHidden`,
    model
  );
};

/**
 * Get services
 * @param params GetServiceQueryParams
 * @returns ServiceDto[]
 */
export const getServices = (params?: GetServiceQueryParams) => {
  return GetAxiosInstance().get<ServiceDto[]>(ServiceLocation.attachment + '/Service', { params });
};

/**
 * Get Tracking Pod Details
 *
 * @param params GetTrackingPoddetailsQueryParams
 * @returns TrackingPodDto[]
 */
export const getTrackingPodDetails = (params?: GetTrackingPoddetailsQueryParams) => {
  return GetAxiosInstance().get<TrackingPodDto[]>(ServiceLocation.attachment + '/Tracking/poddetails', { params });
};
